<div class="pos_rel">
  <h6 class="headh6 d-flex justify-content-between">
    <div>
      <!-- <span class="pointer mr-2" (click)="backToInvoice()">
        <mat-icon class="goBack_pos" svgIcon="back_arrow"></mat-icon>
      </span> -->
      {{ documentType }} History -
      <span class="f-13">
        {{documentType}} Number : <span style="color: #2b96e2">{{ invoiceNumber }}</span>
      </span>
    </div>
    <div class="d-flex">
      <button *ngIf="erpName == 'Dynamics' && portalName == 'customer'" class="primary_btn f-12 mr-3" (click)="openWorkFlow()">
        View Workflow Journey
      </button>
      <button class="primary_btn f-12" (click)="download()">
        View Journey Document
      </button>
    </div>
  </h6>

  <div class="max-h" *ngIf="documentType == 'Invoice'">
    <div class="bg-design-all b-top-left p-2">
      <span *ngFor="let item of statusData; let i = index">
        <span
          [ngStyle]="{
            visibility: item?.DocumentHistoryLogINV?.CreatedOn
              ? 'visible'
              : 'hidden'
          }"
          class="date_box"
          [class.circle-desc-active]="
            orderStatus == item?.dochistorystatus && i == statusData?.length - 1
          "
        >
          <span *ngIf="item?.DocumentHistoryLogINV?.CreatedOn">{{
            item?.DocumentHistoryLogINV?.CreatedOn + "Z" | date : "medium"
          }}</span>
        </span>
        <span
          class="circles"
          [class.active]="
            orderStatus == item?.dochistorystatus && i == statusData?.length - 1
          "
        ></span>
        <!-- <span class="material-icons circles" [class.active]="((orderStatus == item.dochistorystatus) && (i == statusData.length-1))">
                    check_circle
                </span> -->

        <div
          class="circle-desc"
          [class.circle-desc-active]="
            orderStatus == item?.dochistorystatus && i == statusData?.length - 1
          "
          [ngStyle]="{
            color: item?.dochistorystatus?.includes('Rejected') ? 'red' : ''
          }"
        >
          <div class="row">
            <div class="col-sm-4 status_text">{{ item?.dochistorystatus }}</div>
            <div class="col-sm-7">
              <div>
                <span class="f-12">Done by</span> :
                <span
                  style="font-weight: 500"
                  *ngIf="item?.firstName || item?.lastName"
                  >{{ item?.firstName }} {{ item?.lastName }}</span
                >
                <span
                  style="font-weight: 500"
                  *ngIf="!(item?.firstName || item?.lastName)"
                  >Processed by System Automatically
                </span>
              </div>
              <div *ngIf="item?.DocumentHistoryLogINV?.documentdescription">
                <span class="f-12">Description</span> :
                <span style="font-weight: 500">{{
                  item?.DocumentHistoryLogINV?.documentdescription
                }}</span>
              </div>
              <div
                *ngIf="
                  item?.documentFinancialStatus &&
                  item?.documentFinancialStatus != 'UNKNOWN'
                "
              >
                <span class="f-12">Finance Info</span> :
                <span style="font-weight: 500">{{
                  item?.documentFinancialStatus
                }}</span>
              </div>
            </div>
            <div class="f-12 rotateText col-sm-1">DONE</div>
          </div>
        </div>
        <span class="bar" *ngIf="i != statusData?.length - 1"></span>
      </span>
    </div>
  </div>

  <div class="max-h" *ngIf="documentType == 'GRN'">
    <div class="bg-design-all b-top-left p-2">
      <span *ngFor="let item of statusData; let i = index">
        <span
          [ngStyle]="{
            visibility: item?.DocumentHistoryLogGRN?.CreatedOn
              ? 'visible'
              : 'hidden'
          }"
          class="date_box"
          [class.circle-desc-active]="
            orderStatus == item?.dochistorystatus && i == statusData?.length - 1
          "
        >
          <span *ngIf="item?.DocumentHistoryLogGRN?.CreatedOn">{{
            item?.DocumentHistoryLogGRN?.CreatedOn + "Z" | date : "medium"
          }}</span>
        </span>
        <span
          class="circles"
          [class.active]="
            orderStatus == item?.dochistorystatus && i == statusData?.length - 1
          "
        ></span>
        <!-- <span class="material-icons circles" [class.active]="((orderStatus == item.dochistorystatus) && (i == statusData.length-1))">
                    check_circle
                </span> -->

        <div
          class="circle-desc"
          [class.circle-desc-active]="
            orderStatus == item?.dochistorystatus && i == statusData?.length - 1
          "
          [ngStyle]="{
            color: item?.dochistorystatus?.includes('Rejected') ? 'red' : ''
          }"
        >
          <div class="row">
            <div class="col-sm-4 status_text">{{ item?.dochistorystatus }}</div>
            <div class="col-sm-7">
              <div>
                <span class="f-12">Done by</span> :
                <span
                  style="font-weight: 500"
                  *ngIf="item?.firstName || item?.lastName"
                  >{{ item?.firstName }} {{ item?.lastName }}</span
                >
                <span
                  style="font-weight: 500"
                  *ngIf="!(item?.firstName || item?.lastName)"
                  >Processed by System Automatically
                </span>
              </div>
              <div *ngIf="item?.DocumentHistoryLogGRN?.documentdescription">
                <span class="f-12">Description</span> :
                <span style="font-weight: 500">{{
                  item?.DocumentHistoryLogGRN?.documentdescription
                }}</span>
              </div>
              <div
                *ngIf="
                  item?.documentFinancialStatus &&
                  item?.documentFinancialStatus != 'UNKNOWN'
                "
              >
                <span class="f-12">Finance Info</span> :
                <span style="font-weight: 500">{{
                  item?.documentFinancialStatus
                }}</span>
              </div>
            </div>
            <div class="f-12 rotateText col-sm-1">DONE</div>
          </div>
        </div>
        <span class="bar" *ngIf="i != statusData?.length - 1"></span>
      </span>
    </div>
  </div>
</div>
<div class="back_btn">
  <button class="secondary_btn f-12" (click)="backToInvoice()">Back</button>
</div>

<ng-template #popContent let-comment="comments">
  <ng-container>
    <div class="f-12">
      <div>
        <span class="f-13">Done by</span> :
        <span style="font-weight: 500"
          >{{ comment?.firstName }} {{ comment?.lastName }}</span
        >
      </div>
      <div *ngIf="comment?.DocumentHistoryLogINV?.CreatedOn">
        <span class="f-13">Time</span> :
        <span style="font-weight: 500">{{
          comment?.DocumentHistoryLogINV?.CreatedOn + "Z" | date : "medium"
        }}</span>
      </div>
      <div *ngIf="comment?.DocumentHistoryLogINV?.documentdescription">
        <span class="f-13">Description</span> :
        <span style="font-weight: 500">{{
          comment?.DocumentHistoryLogINV?.documentdescription
        }}</span>
      </div>
      <div
        *ngIf="
          comment?.documentFinancialStatus &&
          comment?.documentFinancialStatus != 'UNKNOWN'
        "
      >
        <span class="f-13">Finance Info</span> :
        <span style="font-weight: 500">{{
          comment?.documentFinancialStatus
        }}</span>
      </div>
    </div>
    <!-- <div class="f-12">Please re-upload invoice</div> -->
  </ng-container>
</ng-template>

<ng-template #popTitle let-language="language">Status Info</ng-template>

<p-dialog
  header="Workflow Status"
  [(visible)]="workflowBool"
  position="right"
  [modal]="true"
  [style]="{ width: '80vw', height: '100vh', margin: '0px' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
    <div class="d-flex mt-3 mb-3">
      <div class="card mr-3 f-12">
        <div>Invoice Number</div>
        <div class="f700">{{ workflowData?.invoice_number }}</div>
      </div>
  
      <div class="card f-12">
        <div>Data Area Id</div>
        <div class="f700">{{ workflowData?.data_area_id }}</div>
      </div>
    </div>

    <div class="container-fluid" *ngIf="workflowData?.workflow_details?.length > 0">
      <div class="table-responsive workflow f-12">
        <table class="table table-bordered text-left">
          <tbody>
            <tr style="position: relative;">
              <td class="tLabel"><strong><div class="commentRecord">Updated Record</div></strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">
                <div class="commentRecord">
                  Comment Created On: {{ record.TrackingCommentCreateDateTime }}
                </div>
              </td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Originator</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">{{ record.Originator }}</td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Owner</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">{{ record.Owner }}</td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Tracking Comment</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">
                <div style="max-width: 300px;" title="{{ record.TrackingComment }}">
                  {{ record.TrackingComment }}
                </div>
              </td>
            </tr>

            <tr>
              <td class="tLabel"><strong>Tracking Context</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">
                <div style="max-width: 300px;" title="{{ record.TrackingContext }}">
                  {{ record.TrackingContext }}
                </div>
              </td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Tracking Message</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">
                <div style="max-width: 300px;" title="{{ record.TrackingMessage }}">
                  {{ record.TrackingMessage }}
                </div>
              </td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Tracking Status</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">
                <span [ngClass]="record.TrackingStatus === 'Cancelled' ? 'text-danger font-weight-bold' : 'text-warning font-weight-bold'">
                  {{ record.TrackingStatus }}
                </span>
              </td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Tracking Type</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">{{ record.TrackingType }}</td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>User Name</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">{{ record.UserName }}</td>
            </tr>
    
            <tr>
              <td class="tLabel"><strong>Workflow Type</strong></td>
              <td *ngFor="let record of workflowData?.workflow_details">{{ record.WorkFlowType }}</td>
            </tr>
    
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="workflowData?.workflow_details.length == 0" class="text-center mt-5">
      <div class="text-center f-12">No Workflow Status Found</div>
    </div>
    
    
</p-dialog>

<ngx-spinner
  bdColor="rgba(251, 251, 251, 0.8)"
  size="medium"
  color="#070900"
  [fullScreen]="false"
  type="ball-spin-clockwise"
>
  <div class="loader_text">Hey, please wait...</div>
</ngx-spinner>
